export const LIMIT_KEYS = [
  'contacts',
  'storage_gb',
  'whatsapp_devices',
  'users',
  'viewer_seats',
  'pbx_extensions',
  'branches',
  'monthly_messages',
  'monthly_sms',
  'forms',
  'academy_courses',
  'ai_credits_monthly',
  'custom_domains',
] as const;

export type LimitKey = typeof LIMIT_KEYS[number];

export const LIMIT_LABELS: Record<LimitKey, { label: string; unit?: string }> = {
  contacts: { label: 'Contacts' },
  storage_gb: { label: 'Storage', unit: 'GB' },
  whatsapp_devices: { label: 'WhatsApp devices' },
  users: { label: 'Users' },
  viewer_seats: { label: 'Viewer seats' },
  pbx_extensions: { label: 'PBX extensions' },
  branches: { label: 'Branches' },
  monthly_messages: { label: 'Monthly messages' },
  monthly_sms: { label: 'Monthly SMS' },
  forms: { label: 'Forms' },
  academy_courses: { label: 'Academy courses' },
  ai_credits_monthly: { label: 'AI credits / month' },
  custom_domains: { label: 'Custom domains' },
};

export type StandardLimits = Partial<Record<LimitKey, number>>;

export type WhiteLabelLevel = 'none' | 'half' | 'full';

export const WHITE_LABEL_LEVELS: WhiteLabelLevel[] = ['none', 'half', 'full'];

export const WHITE_LABEL_LABELS: Record<WhiteLabelLevel, string> = {
  none: 'None',
  half: 'Half',
  full: 'Full',
};
